<!--  -->
<template>
  <div>
    <section class="admission-area">
        <div class="w3layoutscontaineragileits">
            <div class="img-edge-cover"><img src="/static/images/bg_ta.png"/></div>
            <h2 class="title">个人信息</h2>
            <div class="lightline"></div>
            <div>
                 <div class="row detail-info">
                    <div class="col-lg-4 form-group">
                        <label class="form-label">姓名</label>
                        <input class="form-control" type="text" v-model="user.name" placeholder="你的姓名" disabled>
                    </div><!-- end col-lg-6 -->

                    <div class="col-lg-4 form-group">
                        <label class="form-label">性别</label>
                            <div class="course-filter">
                            <div class="courses-ordering">
                            <select class="target-course" v-model="user.sex">
                                <option value="男">男</option>
                                <option value="女">女</option>
                            </select>
                            </div>
                            </div>
                    </div><!-- end col-lg-6 -->
                    <div class="col-lg-4 form-group">
                        <label class="form-label">身份证号码</label>
                        <input class="form-control" type="text" v-model="user.identificationcard" placeholder="身份证号码" disabled>
                    </div><!-- end col-lg-6 -->
                    <div class="col-lg-4 form-group">
                        <label class="form-label">出生年月</label>
                        <div class="course-filter ">
                                <el-date-picker
                                v-model="user.birthday"
                                type="date"
                                placeholder="选择日期">
                            </el-date-picker>
                        </div><!-- end course-filter -->
                    </div><!-- end col-lg-6 -->
                    <div class="col-lg-4 form-group">
                        <label class="form-label">邮箱</label>
                        <input class="form-control" type="email"  v-model="user.email" placeholder="你的邮箱">
                    </div>
                        <div class="col-lg-4 form-group">
                        <label class="form-label">所学科目</label>
                        <div class="course-filter">
                            <div class="courses-ordering">
                                <el-tag
                                    style="margin-left: 5px;"
                    v-for="tag in paperSubs"
                                    :key="tag"
                                    >
                                    {{tag}}
                                </el-tag>
                            </div><!-- end courses-ordering -->
                        </div><!-- end course-filter -->
                    </div><!-- end col-lg-6 -->
                        <div class="col-lg-6">
                        <button class="theme-btn" @click="visibleChgPwd=true;">修改密码</button>
                    </div><!-- end col-md-12 -->
                </div><!-- end row -->
                <div class="aitssendbuttonw3ls">
                    <input type="submit" @click="updateInfo()" value="提交修改">
                    <div class="clear"></div>
                </div>
                
            </div>
        </div>
        <div class="container">
            <div class="row">
                <div class="col-lg-10 mx-auto">
                    <div class="admission-body">
                        <div class="contact-form-action">
                            <!--Contact Form-->
                            <div method="#">
                               
                            </div>
                        </div><!-- end contact-form-action -->
                    </div><!-- end admission-body -->
                </div><!-- end col-lg-10 -->
            </div><!-- end row -->
        </div><!-- end container -->
    </section><!-- end admission-area -->
    <el-dialog
        title="输入新密码"
        :visible.sync="visibleChgPwd"
        width="30%"
        center>
        <el-form :model="ruleForm" status-icon :rules="rules" ref="ruleForm" label-width="100px" class="demo-ruleForm">
            <el-form-item label="原密码" prop="currentPassword">
                <el-input  type="password" v-model="ruleForm.currentPassword"></el-input>
            </el-form-item>
            <el-form-item label="密码" prop="newPassword">
                <el-input type="password" v-model="ruleForm.newPassword" autocomplete="off"></el-input>
            </el-form-item>
            <el-form-item label="确认密码" prop="checkPass">
                <el-input type="password" v-model="ruleForm.checkPass" autocomplete="off"></el-input>
            </el-form-item>
            <el-form-item>
                <el-button type="primary" @click="chgPassword('ruleForm')">提交</el-button>
                <el-button @click="resetForm('ruleForm')">重置</el-button>
            </el-form-item>
        </el-form>
        </el-dialog>
  </div>
</template>

<script>
import {Message} from "element-ui";
export default {
  data () {
    var checkAge = (rule, value, callback) => {
        if (!value) {
            return callback(new Error('请输入原密码'));
        }else{
            callback();
        }
    };
    var validatePass = (rule, value, callback) => {
        if (value === '') {
            callback(new Error('请输入新密码'));
        } else {
            if (this.ruleForm.checkPass !== '') {
            this.$refs.ruleForm.validateField('checkPass');
            }
            callback();
        }
    };
    var validatePass2 = (rule, value, callback) => {
    if (value === '') {
        callback(new Error('请再次输入密码'));
    } else if (value !== this.ruleForm.newPassword) {
        callback(new Error('两次输入密码不一致!'));
    } else {
        callback();
    }
    };
    return {
        user:{
           
        },
        paperSubs:[],
         visibleChgPwd:false,
        ruleForm: {
          newPassword: '',
          checkPass: '',
          currentPassword: ''
        },
        rules: {
          newPassword: [
            { validator: validatePass, trigger: 'blur' }
          ],
          checkPass: [
            { validator: validatePass2, trigger: 'blur' }
          ],
          password: [
            { validator: checkAge, trigger: 'blur' }
          ]
        }
    };
  },

  components: {},

  computed: {},

  mounted(){
      this.$axios.get("/api/auth/me").then(res => {
          this.user = res.data.data;
            let arrhasCourse = [];
            for (var i = 0; i <res.data.data.needexaminee.length; i++)
            {
                arrhasCourse.push(res.data.data.needexaminee[i].coursetype);
            }
            this.paperSubs = arrhasCourse;
        })
  },

  methods: {
      updateInfo(){
          this.$axios.put("/api/auth/updatedetails", this.user).then(res => {
                if(res.data){
                    Message.success("更新成功");
                }
          })
      },
      chgPassword(formName){
        this.$refs[formName].validate((valid) => {
          if (valid) {
            //alert('submit!');
            this.$axios.put("/api/auth/updatePassword", this.ruleForm).then(res => {
                if(res.data){
                    Message.success("更新成功");
                }
                this.visibleChgPwd = false;
            })
          } else {
            //console.log('error submit!!');
            return false;
          }
        });
      },
      resetForm(formName) {
        this.$refs[formName].resetFields();
      }
  }
}

</script>
<style scoped>

.w3layoutscontaineragileits{
  width: 1200px;
  height: 504px;
  
  border: 1px solid #4182CA;
  box-shadow: 0px 2px 10px 1px rgba(66, 130, 202, 0.2), 0px 1px 2px 0px #FFFFFF;
  
  background: linear-gradient(0deg, #BEDAF8, #EDF6FF, #FFFFFF);
  background-image:url('/static/images/bg_ta.png') no-repeat bottom left;
  margin:48px auto 76px;
}
.lightline{
  width:1200px;
height: 1px;
background: #ffffff;
box-shadow: 0px 6px 7px 0px rgba(66, 130, 202, 0.5);
}
.title{
  text-align: center;
        margin-top: 41px;
    margin-bottom:27px ;
    font-size: 32px;
/* font-weight: bold; */
color: #4282CA;
font-family: PingFang-SC-Medium;
}
.form-control{
  width: 100%;
  height: 52px;
  background: #FFFFFF;
  border: 1px solid #4282CA;
  opacity: 0.75;
  border-radius: 3px;
  /* margin: 48px auto; */
    display: block;
    /* padding: 0 65px; */
}
/deep/ .el-input--prefix .el-input__inner{
      width: 100%;
  height: 52px;
  background: #FFFFFF;
  border: 1px solid #4282CA;
  opacity: 0.75;
  border-radius: 3px;
  /* margin: 48px auto; */
    display: block;
}
.target-course{
    width: 100%;
  height: 52px;
  background: #FFFFFF;
  border: 1px solid #4282CA;
  opacity: 0.75;
  border-radius: 3px;
  /* margin: 48px auto; */
    display: block;
}
.agiletext{
  width: 111px;
  height: 14px;
  font-size: 14px;
  font-family: PingFang-SC-Medium;
  font-weight: 500;
  color: #636A76;
  line-height: 43px;
}
.agileinfotickwthree{
  position: relative;
  margin-left: 56px;
}
.aitssendbuttonw3ls{
  text-align:center;
}
.aitssendbuttonw3ls input{
  position: relative;
  background-image: url('/static/images/btn_tijaxiugai.png');
  background-repeat: no-repeat;
  margin: auto;
  text-align:center;
  width: 217px;
  height: 68px;
  border:0;
font-size: 24px;
font-family: PingFang-SC-Medium;
font-weight: 500;
color: #FFFFFF;
line-height: 30px;
}
.img-edge-cover {
  position:absolute;
  width: 253px;
       top: 368px;
}
.img-edge-cover img{
    width: 253px;
    display: block;
    margin-bottom: 20px;
        opacity: 0.7;
}
.form-label{
    font-size: 16px;
    font-family: PingFang SC;
    font-weight: bold;
    color: #313F57;
}
.form-group{ 
}
.detail-info{
   margin-top: 55px;     
       padding-left: 15px;
    padding-right: 15px;
}

</style>